import type { FieldOption } from '../../components/workflow/types/workflow';

export const CSAT_RATING_VALUES: FieldOption[] = [
  { label: '😔', value: '1' },
  { label: '😐', value: '2' },
  { label: '😊', value: '3' },
  { label: '😃', value: '4' },
  { label: '😍', value: '5' },
];
